//=====================================================
// 予約キャンセルボタン
//=====================================================
interface IFProps {
    enable : boolean,
    onClick? : React.MouseEventHandler<HTMLButtonElement>}

export function BtnReservationCancel(props: IFProps){

    return (
        <>
            { props.enable ?
                <button onClick={props.onClick} className="btn btn-reserve-cancel">キャンセル</button>
                :
                <button className="btn btn-reserve-cancel is-inactive">キャンセル不可</button>
            }
        </>
    );

}